// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/oferts-ebb/list',
    name: 'ofertsEBB-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/administration/ofertsEBB/List.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'oferts',
    },
  },
]

export default formTable
